export const aciBus = {
    iconName: 'bus',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M19 16a1.333 1.333 0 11-2.666 0A1.333 1.333 0 0119 16zM8.333 16a1.333 1.333 0 11-2.666 0 1.333 1.333 0 012.666 0zM16.333 16h-8',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M19 16h2.667A1.333 1.333 0 0023 14.666l-.295-1.771a2.666 2.666 0 00-2.63-2.228h-1.742l-2.536-3.55A2.667 2.667 0 0013.627 6H5a2 2 0 00-2 2v3.568',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M5.667 16H5a2 2 0 01-2-2v-3.913M18.334 10.666H3M12.334 6v10M7.667 10.667V6',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
